export const guaQuotes = [
  `칠일래복(七日來復)\n
원문: 七日來復，利有攸往。(지뢰복 - 괘사)\n
‘일곱 날 만에 다시 돌아온다’는 뜻으로, 주역의 복괘(復卦)에 나오는 말입니다.
이 말은 잘못된 길로 가더라도 결국에는 본래의 바른 길로 되돌아오게 된다는 자연의 순환을 상징합니다.
여기서 말하는 '일곱 날'은 상징적인 시간으로, 완전히 하나의 사이클을 거친 후의 회복과 재시작을 의미하죠.
모든 일에는 때가 있으며, 돌아올 수 있는 여지를 남기는 태도가 결국 더 큰 회복으로 이어질 수 있습니다.`,

  `대인호변(大人虎變)\n
원문: 大人虎變，未占有孚。(지화명이 - 구오)\n
‘큰 사람이 호랑이처럼 변한다’는 말로, 주역에서 인격적 성숙과 자기 혁신의 과정을 상징합니다.
호랑이의 탈바꿈은 단순한 외형의 변화가 아니라, 근본적인 의식과 자세의 변화를 의미하죠.
이 말은 특히 중요한 전환기나 중대한 결정을 앞둔 사람들에게 깊은 울림을 줍니다.
참된 변화는 외부 환경이 아닌 내면의 결단에서 시작된다는 것, 오늘 우리에게 필요한 태도일지도 모르겠습니다.`,

  `간기지(艮其止)\n
원문: 艮其止，止其所也。(중산간 괘사)\n
‘멈춰야 할 때 멈추는 것이 지혜다’라는 뜻입니다.
주역에서 간(艮)은 산처럼 움직이지 않는 단단함을 의미합니다.
앞만 보고 달리는 것이 능사는 아니며, 때로는 한 걸음을 멈추는 것이 더 나은 방향을 찾게 해줍니다.
오늘 내가 멈춘 그 자리에서, 더 나은 선택의 시간이 자라고 있을지도 모릅니다.`,

  `정강이정(貞剛以正)\n
원문: 貞剛以正，天地之義也。(계사전 하편 6장)\n
'올곧고 굳센 태도는 바로 선 마음에서 온다'는 말입니다.
‘정(貞)’은 주역에서 흔들리지 않는 중심, 원칙을 의미하고, ‘강(剛)’은 외부 요인에 휘둘리지 않는 강단을 나타냅니다.
부드러움이 필요할 때도 있지만, 때로는 자신이 옳다고 믿는 것을 지키는 강한 자세가 더 많은 이에게 신뢰를 줍니다.`,

  `소인용장,군자용망(小人用壯,君子用罔)\n
원문: 小人用壯，君子用罔。貞厲。羝羊觸藩，羸其角。(뇌천대장 - 구삼)\n
'소인은 힘으로 밀어붙이지만, 군자는 속이 투명하고 함정이 없다'는 뜻입니다.
겉으로 보이는 강함이 전부가 아니라, 내면의 맑음이 진정한 힘이라는 교훈을 줍니다.
서두르지 말고, 정직하게 가는 길이 더디더라도 결국 가장 먼 길을 가게 된다는 걸 기억해보세요.`,

  `지길,형(之吉,亨)\n
원문: 之吉，亨。(수화기제 - 상육)\n
‘그 길이 길하고 형통하다’는 말이지만, 단순히 가는 모든 길이 복되다는 뜻은 아닙니다.
진심 어린 목적, 바른 방향, 그리고 때를 아는 지혜가 함께 할 때에만 길이 트이고 일이 순조롭게 풀립니다.
지금 가고 있는 그 길이 정말 내 마음과 뜻에 부합하는지, 돌아보는 하루가 되었으면 합니다.`,

  `계이정(繫以牢)\n
원문: 繫以牢，贞吉，有孚，攣如，无咎。 (수풍정 - 초구)\n
“단단히 매어두어야 한다”는 뜻으로, 연결과 신뢰의 중요성을 강조합니다.
사람과 사람 사이, 목표와 의지 사이의 연결이 느슨하지 않고 단단해야 비로소 길하다는 교훈을 줍니다.
믿음으로 묶인 관계는 흔들림 없이 오래 지속되며, 그것만으로도 복된 길이 됩니다.`,

  `정중유은육(鼎中有隱肉)\n
원문: 鼎中有隱肉，利貞。 (화풍정 - 구오)\n
“솥 안에 고기가 숨겨져 있다”는 말로, 겉보다 속이 중요하다는 뜻을 담고 있습니다.
겉으로 보이지 않는 가치도 중심을 지키고 있다면 언젠가는 드러납니다.
실력과 진정성은 시간이 지나면 반드시 드러나고, 겉치레보다 내실을 다지라는 철학이 담겨 있습니다.`,

  `불극위,원길(弗克違，元吉)\n
원문: 或益之十朋之龟，弗克違，永貞吉。 (풍뢰익 - 육이)\n
“그 뜻을 거스를 수 없으니, 근본적으로 길하다”는 의미입니다.
하늘이나 타인의 선의를 거스르지 않고 기꺼이 받아들이는 태도가 진정한 복을 가져온다는 가르침입니다.
받아들임은 약함이 아니라 순응의 지혜이며, 기회가 왔을 때 의심 없이 응하는 자세가 중요합니다.`,

  `잠룡물용(潛龍勿用)\n
원문: 潛龍勿用。(중천건 - 초구효사)\n
"아직 드러나지 않은 용은 나서지 말아야 한다"는 뜻입니다.
이 말은 능력을 갖춘 사람이라도 때를 기다려야 한다는 깊은 지혜를 담고 있습니다.
군자는 모든 준비를 마치고도 쉽게 나서지 않으며, 조용한 곳에서 때를 지켜봅니다.
성급한 움직임은 오히려 빛을 잃게 만들 수 있습니다.
지금 내가 조용히 머물고 있다면, 그것은 실패가 아니라 더 큰 도약을 위한 응축의 시간일 수 있음을 명심하세요.`,

  `항룡유회(亢龍有悔)\n
원문: 亢龍有悔。(중천건 - 상구효사)\n
"너무 높이 오른 용은 후회를 남긴다"는 뜻입니다.
이는 최고의 자리에 올랐을 때조차 겸손과 자기 성찰이 필요함을 경고하는 말입니다.
높이 오른 자일수록 더 크게 추락할 수 있으며, 그만큼 책임과 위험도 함께 따른다는 뜻이에요.
지금 내가 잘나간다고 느끼는 순간, 오히려 한 발 물러나 자신을 돌아보는 지혜가 필요합니다.
진짜 군자란, 가장 높을 때도 낮음을 아는 사람임을 마음에 세기세요.`,

  `리빈마지정(利牝馬之貞)\n
원문: 坤元亨，利牝馬之貞。君子有攸往，先迷後得主，利西南得朋，東北喪朋。安貞吉。(중지곤 - 괘사)\n
"암말처럼 유순하면서도 중심을 잃지 않는 것이 이롭다"는 뜻입니다.
이는 땅(坤)의 덕목을 따르는 태도로, 모든 것을 품되 스스로 무너지지 않는 유연한 강인함을 뜻합니다.
牝馬(빈마)는 순종의 상징이지만, 아무 생각 없이 따르는 것이 아니라 자기 자리를 알고 흐름에 조화롭게 순응하는 태도를 말합니다.
세상의 큰 흐름과 조화를 이루되, 자신의 중심을 잃지 않는 자세.
그것이 곤괘가 말하는 겉은 부드러우나 속은 굳센 사람의 길입니다.
오늘 내가 취해야 할 자세도 어쩌면, '굽힘 없는 따름'일 수 있습니다.`,

  `비지비인(比之匪人)\n
원문: 比之匪人。(수지비 - 육삼효사)\n
"가까이한 사람이 결국 도리에 맞지 않는 자였다"는 뜻입니다.
이 말은 관계의 시작보다, 함께 가는 방향과 품성이 더 중요하다는 깊은 통찰을 전합니다.
사람이 많고 친해 보이는 것만으로는 충분하지 않습니다.
겉모습이나 친절한 말보다, 그 사람이 어떤 길을 향하고 있는지를 보는 눈이 필요합니다.
오늘 당신 곁에 있는 사람이 함께 가야 할 사람인지, 아니면 거리를 둬야 할 사람인지...
관계는 수(數)가 아니라 질(質)입니다.`,

  `비지무수(比之无首)\n
원문: 比之无首，凶。(수지비 - 상육효사)\n
관계가 있으나, 중심이 없다.
이 말은 "아무리 사이가 좋아도 기준이 없으면 그것은 흩어진 무리일 뿐"이라는 경고입니다.
리더 없는 팀, 책임 없는 우정, 원칙 없는 협력은 결국 흉한 결과로 흘러갑니다.
함께하는 것보다 함께 어디로 가는지가 더 중요합니다.
지금 내가 속한 관계 속에는 방향과 중심이 있는가?
가까움만으로 안심하지 말고, 그 안에 질서와 책임이 깃들어 있는지를 돌아보는 지혜가 필요합니다.`,

  `유부련여, 부이기린(有孚攣如，富以其鄰)\n
원문: 有孚攣如，富以其鄰。(풍천소축 - 구오효사)\n
"믿음이 있고, 마음이 끈처럼 이어져 있다면, 그 풍요는 이웃과 함께 나눌 수 있다"는 의미입니다.
이 말은 진정한 관계는 신뢰에서 시작되며, 그 결과는 공동의 번영으로 이어진다는 뜻입니다.
형식적인 관계보다 마음이 닿은 연결, 표면적인 이익보다 서로를 위한 배려가 오래 갑니다.
지금 내 곁에 있는 사람들과의 관계에 믿음이 깃들어 있는가?
그 관계는 나만의 이익을 위한 연결인가, 아니면 함께 누릴 수 있는 신뢰의 공동체인가?
신의 있는 유대는 결국 모두를 살리는 길이 됩니다.`,

  `리도탄탄, 유인정길(履道坦坦，幽人貞吉)\n
원문: 履道坦坦，幽人貞吉。(천택리 - 구이효사)\n
"바른 길을 차분히 걸어가는 사람, 조용히 자신을 지키면 결국 길하다"는 뜻입니다.
'리도탄탄(履道坦坦)'은 “올바른 길을 걷는 사람의 발걸음은 평탄하다”는 뜻이에요. 
억지로 밀고 나가지 않아도, 옳은 방향으로 걷는 사람은 길이 저절로 열립니다. 조급해 하지 않아도 되고, 다른 사람과 경쟁할 필요도 없죠.
'유인(幽人)'은 세상 앞에 나서지 않고 조용히 살아가는 사람을 말해요. 
그런 사람은 눈에 띄지 않을 수 있지만, 자신의 중심을 잃지 않고 고요하게 도리를 지켜갑니다. 
여기서 '정길(貞吉)'이란, 그렇게 묵묵히 자신의 길을 지킨 사람에게는 결국 좋은 일이 찾아온다는 뜻이에요.
이 효사는 우리에게 이렇게 말해줘요.
크게 나서지 않아도 괜찮다고, 조용히 바른 길을 지켜가기만 해도 충분히 복된 삶에 닿을 수 있다고요.
때로는 조용한 삶이야말로 가장 단단하고 평탄한 길이 됩니다.`,

  `편편, 불부이기린, 불계이부(翩翩，不富以其鄰，不戒以孚)\n
원문: 翩翩，不富以其鄰，不戒以孚。(지천태 - 육사효사)\n
"겉은 가볍고 화려해 보여도, 이웃과 나누지 않으면 참된 부유가 아니다. 경계하지 않아도 믿음이 있다면 그 자체로 든든하다"는 의미입니다.
‘편편(翩翩)’은 겉모습이 날렵하고 멋스러워 보인다는 뜻이에요. 말하자면 세련되고 품위 있어 보이지만, 꼭 그 안에 알맹이가 있다는 보장은 없죠. 
그래서 이 효사는 묻습니다. "겉으로는 그럴듯해 보이지만, 진짜로 이웃과 함께 나누고 있나요?"
‘불부이기린(不富以其鄰)’은 자기 혼자만 잘사는 것이 아니라, 함께 살아가고 있는 이웃과도 그 풍요를 나눠야 한다는 뜻이에요. 
아무리 가진 것이 많아도 그것이 나눔으로 이어지지 않는다면, 진짜 부유하다고 할 수 없죠.
‘불계이부(不戒以孚)’는 조심하거나 경계하지 않아도, 사람들 사이에 신뢰가 있다면 모든 관계가 자연스럽게 잘 흘러간다는 말입니다.
믿음이 있는 관계는 많은 말을 하지 않아도 통하고, 억지로 지키려 애쓰지 않아도 흔들리지 않아요.
이 효사는 우리에게 이렇게 말해줘요.
진짜 좋은 사람은 말이나 겉치레가 아니라, 조용히 믿음을 쌓고, 자기가 가진 것을 이웃과 나누며 살아가는 사람이라고요.
그런 사람이 사는 세상은 말하지 않아도 평화롭고, 나누지 않아도 서로가 따뜻합니다.`,

  `유명, 무구, 추리지(有命，无咎，畴離祉)\n
원문: 有命，无咎，畴離祉。(천지비 - 구사효사)\n
"하늘의 뜻을 따르니 허물이 없고, 마침내 복된 길이 멀지 않다"는 뜻입니다.
이 문장은 세상 일이 아무리 막혀 있는 것처럼 보여도, 자신의 자리를 묵묵히 지키는 사람은 결국 좋은 결과에 닿게 된다는 의미예요.
먼저 ‘유명(有命)’은 “하늘의 명(命)을 따른다”는 뜻이에요. 
쉽게 말하면, 내 힘으로는 어찌할 수 없는 흐름 앞에서 억지로 거슬러 올라가지 않고, 지금 주어진 상황 속에서 자신의 역할을 다하는 것을 말해요. 
세상이 막혀 있는 듯 보여도, 그런 태도에는 허물이 따르지 않죠. 그것이 곧 ‘무구(无咎)’ — “허물이 없다”는 말입니다.
‘추리지(畴離祉)’는 “누가 복에서 멀어지랴”라는 뜻이에요. 
다시 말해, 이렇게 운명을 받아들이고 바르게 사는 사람이라면 복이 멀지 않다는 의미죠.
이 효사는 우리에게 이렇게 말해줘요.
지금 상황이 막혀 있어도 조급해하지 마세요. 내게 주어진 몫을 다하고 바른 길을 지키면, 비록 지금은 답답해도 결국 복이 찾아옵니다.
운명을 원망하기보다 담담히 받아들이고, 묵묵히 자기 자리를 지키는 사람에게는 하늘도 등을 돌리지 않아요.`,

  `선호도이후소(先號咷而後笑)\n
원문: 同人，先號咷而後笑, 大師克相遇。(천화동인 - 구오효사)\n
"사람들과 함께하는 길, 먼저는 통곡하지만 결국엔 웃게 된다. 큰 힘이 합쳐져 마침내 만남이 이루어진다"는 뜻입니다.
사람들과 더불어 살아가는 일은 결코 쉬운 일이 아니에요. 
'선호도(先號咷)'는 처음에는 울고 부르짖는다는 뜻입니다. 누군가를 이해하고, 함께 일하고, 마음을 맞춰가는 과정에서 갈등과 상처, 오해와 눈물이 먼저 찾아올 수 있어요.
우리는 그럴 때 종종 "내가 틀렸나?", "이 길이 맞을까?" 하고 흔들리게 됩니다.
그렇지만 효사는 말합니다. '이후소(而後笑)' — 그 다음엔 웃게 될 거라고.
갈등을 피하지 않고, 서로를 온전히 마주하려는 노력을 멈추지 않는다면, 마침내 웃음으로 마무리되는 순간이 찾아옵니다. 
이 말은 단순한 감정의 전환이 아니라, 진정한 관계의 회복과 깊은 동행이 이루어지는 과정을 말해요.
그 웃음은 우연히 오지 않습니다. 많은 사람들의 힘이 모이고, 인내와 성실함이 쌓인 끝에 마침내 의미 있는 만남이 이루어진다는 거죠.
이 효사는 이렇게 말해줍니다.
사람과의 관계는 처음부터 웃으며 시작되는 것이 아니라, 울며 부딪치고 나서야 비로소 웃게 되는 법입니다.
그러니 지금의 눈물을 너무 두려워하지 마세요. 그 눈물 너머에, 마음이 맞는 사람과의 깊은 웃음이 기다리고 있습니다.`,
]
